import { useTranslation } from 'react-i18next';
import { AppIconButton } from '@/UI/Buttons/AppIconButton';
import { SpeakerHighIcon, SpeakerXIcon } from '@/UI/Icons';
import { I18N_KEYS } from '@/language/keys';

interface SoundButtonProps {
  onToggleMute: () => void;
  hasAudio: boolean;
  muted: boolean;
  width?: number;
  height?: number;
  btnW?: number;
  btnH?: number;
}

export function SoundButton({
  onToggleMute,
  hasAudio,
  muted,
  btnW = 24,
  btnH = 24,
  width = 24,
  height = 24,
}: SoundButtonProps) {
  const { t } = useTranslation();

  return (
    <AppIconButton
      aria-label={t(muted || !hasAudio ? I18N_KEYS.GENERAL.ARIA.UNMUTE : I18N_KEYS.GENERAL.ARIA.MUTE)}
      width={width}
      height={height}
      mode="on-dark"
      onClick={onToggleMute}
      disabled={!hasAudio}
    >
      {muted || !hasAudio ? (
        <SpeakerXIcon width={btnW} height={btnH} />
      ) : (
        <SpeakerHighIcon width={btnW} height={btnH} />
      )}
    </AppIconButton>
  );
}
